import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'aa-tiny-oups',
    templateUrl: './tiny-oups.component.html',
    styleUrls: [
        './tiny-oups.component.scss'
    ],
    standalone: false
})
export class TinyOupsComponent implements OnInit
{
    @Input() title: string = '';
    @Input() message: string = '';

    constructor() { }

    ngOnInit ()
    {
    }
}
